"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _tokens = require("../tokens");

var boxPadding = {
  square: {
    none: {
      top: _tokens.spacing.vertical.none,
      right: _tokens.spacing.horizontal.none,
      bottom: _tokens.spacing.vertical.none,
      left: _tokens.spacing.horizontal.none
    },
    xxs: {
      top: _tokens.spacing.vertical.xxxs,
      right: _tokens.spacing.horizontal.xxxs,
      bottom: _tokens.spacing.vertical.xxxs,
      left: _tokens.spacing.horizontal.xxxs
    },
    xs: {
      top: _tokens.spacing.vertical.xxs,
      right: _tokens.spacing.horizontal.xxs,
      bottom: _tokens.spacing.vertical.xxs,
      left: _tokens.spacing.horizontal.xxs
    },
    sm: {
      top: _tokens.spacing.vertical.xs,
      right: _tokens.spacing.horizontal.xs,
      bottom: _tokens.spacing.vertical.xs,
      left: _tokens.spacing.horizontal.xs
    },
    md: {
      top: _tokens.spacing.vertical.sm,
      right: _tokens.spacing.horizontal.sm,
      bottom: _tokens.spacing.vertical.sm,
      left: _tokens.spacing.horizontal.sm
    },
    lg: {
      top: _tokens.spacing.vertical.md,
      right: _tokens.spacing.horizontal.md,
      bottom: _tokens.spacing.vertical.md,
      left: _tokens.spacing.horizontal.md
    },
    xl: {
      top: _tokens.spacing.vertical.lg,
      right: _tokens.spacing.horizontal.lg,
      bottom: _tokens.spacing.vertical.lg,
      left: _tokens.spacing.horizontal.lg
    }
  },
  squish: {
    xxs: {
      top: _tokens.spacing.vertical.xxxxs,
      right: _tokens.spacing.horizontal.xxxs,
      bottom: _tokens.spacing.vertical.xxxxs,
      left: _tokens.spacing.horizontal.xxxs
    },
    xs: {
      top: _tokens.spacing.vertical.xxxs,
      right: _tokens.spacing.horizontal.xxs,
      bottom: _tokens.spacing.vertical.xxxs,
      left: _tokens.spacing.horizontal.xxs
    },
    sm: {
      top: _tokens.spacing.vertical.xxxs,
      right: _tokens.spacing.horizontal.xs,
      bottom: _tokens.spacing.vertical.xxxs,
      left: _tokens.spacing.horizontal.xs
    },
    md: {
      top: _tokens.spacing.vertical.xxs,
      right: _tokens.spacing.horizontal.xs,
      bottom: _tokens.spacing.vertical.xxs,
      left: _tokens.spacing.horizontal.xs
    },
    lg: {
      top: _tokens.spacing.vertical.xs,
      right: _tokens.spacing.horizontal.sm,
      bottom: _tokens.spacing.vertical.xs,
      left: _tokens.spacing.horizontal.sm
    },
    xl: {
      top: _tokens.spacing.vertical.sm,
      right: _tokens.spacing.horizontal.md,
      bottom: _tokens.spacing.vertical.sm,
      left: _tokens.spacing.horizontal.md
    }
  }
};
var _default = boxPadding;
exports.default = _default;